export default __webpack_public_path__ + "img/normandie.b40af2e8.jpg";